/** The count as screen readers hear it after an add or remove: "1 custom word", "12 custom words". */
export function customWordCount(count: number): string {
  return `${count} custom ${count === 1 ? 'word' : 'words'}`
}
